import type { Nullable } from '@iheartjane/types';

import { api } from '../api';
import type { CommunicationBanner } from './communicationBanner.types';
import { communicationBannerUrls } from './communicationBanner.utils';

/**
 * A store's communication banner
 *   V1::Stores::BannerMessageSettingsController#show
 *   GET /stores/:storeId/banner_message_settings
 */
export const fetchCommunicationBanner = (
  storeId: string | number
): Promise<Nullable<CommunicationBanner>> =>
  api.get<Nullable<CommunicationBanner>>(
    communicationBannerUrls.detail(storeId)
  );
